import * as React from 'react';

import { useRouter } from 'next/router';

import { Stack } from '@mui/system';

import { ButtonTextPrimary, ButtonTextSecondary } from '@itp/talent/components/core/button';

export type AuthFooterLinksProps = {
  leftAction?: {
    href: string;
    label: string;
  };
  rightAction?: {
    href: string;
    label: string;
  };
};

export const AuthFooterLinks: React.FC<AuthFooterLinksProps> = ({ leftAction, rightAction }) => {
  const router = useRouter();

  return (
    <Stack flexDirection="row" justifyContent="space-between">
      {leftAction ? (
        <ButtonTextSecondary onClick={() => router.push(leftAction.href)}>
          {leftAction.label}
        </ButtonTextSecondary>
      ) : (
        <span />
      )}

      {rightAction ? (
        <ButtonTextPrimary onClick={() => router.push(rightAction.href)}>
          {rightAction.label}
        </ButtonTextPrimary>
      ) : (
        <span />
      )}
    </Stack>
  );
};
